import * as React from 'react';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import { track } from '../../utilities';
import { LINK_VARIANT, LinkType } from './variants';

type IProps = {
  linkType?: LinkType;
  children: any;
  className?: string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

const Link = ({
  linkType = 'default',
  children,
  className,
  ...props
}: IProps): ReactElement => {
  const linkClasses = twMerge('link', LINK_VARIANT[linkType], className);

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      track('Link clicked', {
        'url location': location.href,
        'destination url': props.href,
        'button description': children,
      });
    }
  };

  return (
    <a className={linkClasses} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default Link;
